import axios from "axios";

export default axios.create({

    baseURL: "https://test-chp-api-d2b3cchtewg7dxhk.centralindia-01.azurewebsites.net"

});

